import { ChangeDetectionStrategy, Component, input, OnInit, inject, Signal, viewChild } from '@angular/core';

import { Observable, map } from 'rxjs';

import { CustomIcon, SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { GtmService } from '@fcom/common/gtm';
import { ElementActions, ElementTypes, GaContext } from '@fcom/common/interfaces';
import { CmsArticle, CmsTaxonomyGeneral } from '@fcom/core-api';
import {
  ButtonTheme,
  ButtonType,
  IconPosition,
  ModalButtons,
  NotificationButtonStyle,
  NotificationLayout,
  NotificationTheme,
} from '@fcom/ui-components';
import { LanguageService, LocalizationPipe } from '@fcom/ui-translate';
import { AnalyticsFormStatus } from '@fcom/service-forms';

import { DarksiteFormComponent } from './darksite-form/darksite-form.component';
import { IncidentUpdatesService } from '../../../services/darksite/incident-updates.service';

@Component({
  selector: 'fin-emergency-in-operations-article',
  templateUrl: './emergency-in-operations-article.component.html',
  styleUrl: './emergency-in-operations-article.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EmergencyInOperationsArticleComponent implements OnInit {
  private finLocalization = inject(LocalizationPipe);
  private gtmService = inject(GtmService);
  private incidentUpdatesService = inject(IncidentUpdatesService);
  private languageService = inject(LanguageService);

  readonly ButtonTheme = ButtonTheme;
  readonly ButtonType = ButtonType;
  readonly CmsTaxonomyGeneral = CmsTaxonomyGeneral;
  readonly CustomIcon = CustomIcon;
  readonly ElementTypes = ElementTypes;
  readonly GaContext = GaContext;
  readonly IconPosition = IconPosition;
  readonly ModalButtons = ModalButtons;
  readonly NotificationButtonStyle = NotificationButtonStyle;
  readonly NotificationLayout = NotificationLayout;
  readonly NotificationTheme = NotificationTheme;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  emergencyInOperationsTexts$: Observable<Record<string, string>>;
  homeLink$: Observable<string>;
  modalOpen = false;
  publishedText: string;
  updatedText: string;

  content = input<CmsArticle>();
  darksiteForm: Signal<DarksiteFormComponent> = viewChild<DarksiteFormComponent>(DarksiteFormComponent);

  ngOnInit(): void {
    this.homeLink$ = this.languageService.lang.pipe(map((lang): string => `/${lang}`));
    this.publishedText = this.finLocalization.transform('shared.published');
    this.updatedText = this.finLocalization.transform('shared.updated');
    this.emergencyInOperationsTexts$ = this.languageService.translate<Record<string, string>>('emergencyInOp');
  }

  openModal(): void {
    this.modalOpen = true;
    this.gtmService.trackElement(
      AnalyticsFormStatus.INCIDENT_UPDATES,
      'incident-updates',
      ElementTypes.BUTTON,
      'open-modal',
      ElementActions.CLICK
    );
  }

  closeModal(): void {
    this.modalOpen = false;

    // only reset the component on close if a submission has been successful (formEnds = true)
    // in case user accidentally closes while interacting with the form
    if (this.darksiteForm() && this.incidentUpdatesService.formEnds()) {
      this.darksiteForm().ngOnDestroy();
      this.incidentUpdatesService.formEnds.set(false);
    }
  }
}
